import React from 'react';
import { Download } from 'phosphor-react';

import * as S from './styles';

const TermsReader: React.FC = () => {
  const onDownloadButtonClick = React.useCallback(() => {
    window.open(
      'https://s3.us-west-2.amazonaws.com/app.profitfy.me-media/terms/Termos+Profitfy+%26+Mamba.pdf',
      '_blank',
    );
  }, []);

  return (
    <S.Wrapper>
      <S.DownloadButton onClick={onDownloadButtonClick}>
        <Download size={20} color="#fff" weight="bold" />
      </S.DownloadButton>

      <S.Title>Termos de Adesão</S.Title>

      <S.Paragraph>Ao aceitar este termo, declaro que:</S.Paragraph>

      <S.Paragraph>
        1. Concordo com o compartilhamento de todos os dados de minha operação com a Mamba Culture
        Publicidade e Consultoria Ltda. (&quot;MAMBA&quot;), inscrita no CNPJ/ME sob nº
        37.552.089/0001-09, incluindo, mas não se limitando ao volume de vendas, valores investidos
        em anúncios, lucros, dados de produtos, custos operacionais e os demais dados presentes na
        plataforma da Profitfy, com exceção de dados pessoais;
      </S.Paragraph>

      <S.Paragraph>
        2. Autorizo a MAMBA a utilizar essas informações para análise e diagnóstico da minha
        operação, com a finalidade de melhorar meus resultados e minha performance em vendas e
        publicidade;
      </S.Paragraph>
      <S.Paragraph>
        3. Estou ciente de que, na hipótese de intenção de revogação desta autorização de acesso aos
        meus dados, precisarei contatar o time da Profitfy e perderei os benefícios de análise da
        minha operação pela MAMBA;
      </S.Paragraph>
      <S.Paragraph>
        4. Li e compreendi todas as cláusulas aqui presentes, bem como concordo com os termos e
        condições nele estabelecidos.
      </S.Paragraph>
      <S.Paragraph>
        O presente termo tem validade a partir da data de aceitação pelo Usuário e permanecerá
        válido enquanto perdurar a relação comercial entre o Usuário e a MAMBA, ou até a solicitação
        de revogação da autorização de acesso pelo Usuário à Profitfy, o que ocorrer primeiro.
      </S.Paragraph>

      <S.Subtitle>Estes Termos foram atualizados em 16 de maio de 2023.</S.Subtitle>
    </S.Wrapper>
  );
};

export default TermsReader;
